import { TFunction } from 'i18next';
import React, { FunctionComponent } from 'react';
import IconsSetMenu from '../Icons';

interface ProgressUploadProps {
  percent: number;
  t: TFunction;
}

const ProgressUpload: FunctionComponent<ProgressUploadProps> = ({percent, t}) => {
  return (
    <div className="w-100 h-100 display-flex flex-column align-items-center">
      <div className="display-flex flex-column justify-content-center align-items-center" style={{flex: 19}}>
        <div className="rounded-grey-icon">
          <IconsSetMenu icon={percent >= 50 ? 'ic-traitement' : 'ic-cloud-upload'} size={40} />
        </div>
        <span className="font14 grey mt-1">{percent >= 50 ? t('loader_treatment_in_progress') : t('loader_send_in_progress')}</span>
      </div>
      <div className="w-100" style={{backgroundColor: '#F2F2F2', flex: 1}}>
        <div className="loader-upload h-100" style={{width: percent.toFixed(2).concat('%')}}></div>
      </div>
    </div>
  );
};

export default ProgressUpload;
